export default __webpack_public_path__ + "static/media/pokemon-deck-builder.ee9eb176.png";